export const publicVersion = "2.8.0-0-g84bda95a-2026-05-15T14-10-48Z";